import React from 'react';
import './Styles/Subscribe.scss';

const Subscribe=()=>{
    return(
        <div className="blog-subscribe">
<h1>Add some text to explain benefits of subscripton on your services.</h1>
             <div className="inputs">
                 <input type="email" placeholder="Please enter your email address" />
                 <button>Subscribe</button>
             </div>
        </div>
    )
};
export default Subscribe;